import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "replenish-dialog-content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "time" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "time_icno",
  src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/user_center_history.svg",
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "tip" }
const _hoisted_6 = {
  key: 0,
  class: "replenish-dialog-tab"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/CN.png",
  alt: ""
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/JP.png",
  alt: ""
}, null, -1)
const _hoisted_9 = { class: "table" }
const _hoisted_10 = { class: "goods-content" }
const _hoisted_11 = { class: "line--2 name" }
const _hoisted_12 = { style: {"margin-top":"10px"} }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { style: {} }
const _hoisted_15 = { class: "submit-btn" }

import { t } from '@/plugins/i18n'
import { ref, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import dayjs from 'dayjs'
import { request } from '@/config/request/interceptors'
import { WaitReplenishItemRespDTO, ReplenishOrderStatRespDTO } from '@/service/order'
import router from '@/router'
import { useRtfix } from '@/store'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const isJpPurchaseJP = () => store.getters.isJpPurchase
const tab = ref<'CN' | 'JP'>('CN')
const dataSource = ref<WaitReplenishItemRespDTO[]>([])
const dialogVisible = ref(false)
const pageQuery = ref({
  total: 100,
  pageSize: 10,
  pageNum: 1
})
const _paginationConfig = ref({
  total: 0,
  current: 1,
  pageSize: 10,
  pageSizes: [10, 20, 30, 50],
  layout: ' prev, pager, next, sizes, jumper ',
  background: true
})
const changePage = () => {
  getList()
}
const changeSize = () => {
  pageQuery.value.pageNum = 1
  getList()
}
const getList = async (tabVal = tab.value) => {
  const res = await request.order.customer.replenishOrderQueryWaitReplenishItems({
    customerShopId: store.getters.curShop,
    purchaseCountry: tabVal,
    pageSize: pageQuery.value.pageSize,
    pageNum: pageQuery.value.pageNum
  })
  if (res?.data?.total) {
    dialogVisible.value = true
  }
  dataSource.value = res.data?.records || []
  pageQuery.value.total = res.data?.total || 0
  return res.data?.total || 0
}

const replenishInfo = ref<Record<'CN' | 'JP', ReplenishOrderStatRespDTO>>({
  JP: {},
  CN: {}
})
const changeTab = (type: 'CN' | 'JP') => {
  console.log(type)
  tab.value = type
  pageQuery.value.pageNum = 1
  getList()
}
/** 关闭弹窗 */
const closeModal = (done?: any) => {
  const localStorageData = JSON.parse(window.localStorage.getItem('usercenterReplenishDialogStorage') ?? '{}')
  localStorageData[store.getters.curShop] = dayjs().format('YYYY-MM-DD HH:mm:ss')
  window.localStorage.setItem('usercenterReplenishDialogStorage', JSON.stringify(localStorageData))
  done?.()
}
const updateTime = ref('')

onMounted(async () => {
  await store.dispatch('status/setJpPurchase', {}, { root: true })
  const localStorageData = JSON.parse(window.localStorage.getItem('usercenterReplenishDialogStorage') ?? '{}')
  const resData = await request.order.customer.replenishOrderStatistics({
    purchaseCountry: 'CN'
  })

  replenishInfo.value.CN = resData.data!
  let resData2: any = {}
  if (isJpPurchaseJP()) {
    resData2 = await request.order.customer.replenishOrderStatistics({
      purchaseCountry: 'JP'
    })
    replenishInfo.value.JP = resData2.data!
  }
  updateTime.value = resData?.data?.maxCreateTime ?? resData2?.data?.maxCreateTime ?? ''
  if (!!resData?.data?.totalWaitReplenishQuantity || !!resData2?.data?.totalWaitReplenishQuantity) {
    const time = localStorageData[store.getters.curShop]
    if (!time || (new Date(time).getTime() < new Date(updateTime.value).getTime())) {
      const res = await getList('CN')
      if (res) {
        tab.value = 'CN'
        return
      }
      const res1 = await getList('JP')
      if (res1) {
        tab.value = 'JP'
      }
    }
  }
})

const handleOrderList = () => {
  closeModal()
  if (tab.value === 'JP') {
    router.push(useRtfix('purchaseManageList'))
  } else {
    router.push(useRtfix('OrderList', { query: { platformOrderStatus: 2 } }))
  }
}

/** 查看补货明细 */
const handleCheckDetail = (item: WaitReplenishItemRespDTO) => {
  closeModal()
  if (tab.value === 'JP') {
    router.push(useRtfix('SyncOrder', { query: { orderSyncStatus: 3, productSku: item.productSku } }))
  } else {
    router.push(useRtfix('SyncOrder', { query: { orderSyncStatus: 2, productSku: item.productSku } }))
  }
}
/** 编辑补货数量 */
const handleEditNum = (item: WaitReplenishItemRespDTO) => {
  closeModal()
  if (tab.value === 'JP') {
    router.push(useRtfix('purchaseManagePlanDetail', { query: { replenishOrderNo: item.replenishOrderNo } }))
  } else {
    if (replenishInfo.value.CN.platformOrderNos?.includes(',')) {
      router.push(useRtfix('OrderList', { query: { platformOrderNo: replenishInfo.value.CN.platformOrderNos } }))
    } else {
      router.push(useRtfix('ConfirmOrder', { query: { id: item.platformOrderId, sc: 'CN', isReplenish: 1 } }))
    }
  }
}
const close = () => {
  closeModal()
  dialogVisible.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogVisible).value = $event)),
    width: "500",
    "custom-class": "replenish-dialog",
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "before-close": closeModal,
    zIndex: 3008
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('已生成最新的补货计划（待支付）')), 1),
          _createElementVNode("span", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_unref(t)('更新时间')) + "： " + _toDisplayString(_unref(dayjs)(replenishInfo.value?.[tab.value]?.maxCreateTime).add(1, 'hours').format('YYYY-MM-DD HH:mm')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('以下商品需要补货，请及时支付补货囤货单，如不处理会影响API订单时效')), 1),
        (isJpPurchaseJP())
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (replenishInfo.value?.CN?.totalWaitReplenishQuantity)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["tab-item", { active: tab.value == 'CN' }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab('CN')))
                  }, [
                    _hoisted_7,
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('中国')), 1)
                  ], 2))
                : _createCommentVNode("", true),
              (replenishInfo.value?.JP?.totalWaitReplenishQuantity)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["tab-item", { active: tab.value == 'JP' }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab('JP')))
                  }, [
                    _hoisted_8,
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('日本')), 1)
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_table, {
            data: dataSource.value,
            style: {"width":"100%"},
            height: 400
          }, {
            default: _withCtx(() => [
              (tab.value == 'JP')
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    prop: "customerSupplierName",
                    label: _unref(t)('供应商'),
                    width: "160"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(scope.row.customerSupplierName ?? '-'), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, {
                prop: "productSku",
                label: _unref(t)('商品SKU')
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "recommendReplenishQuantity",
                label: _unref(t)('建议补货数量'),
                width: "150"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "historyReplenishQuantity",
                label: _unref(t)('历史需补货数')
              }, null, 8, ["label"]),
              (tab.value == 'CN')
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 1,
                    prop: "cancelReplenishQuantity",
                    label: _unref(t)('被取消需补货数')
                  }, null, 8, ["label"]))
                : (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 2,
                    prop: "purchaseUnuseQuantity",
                    label: _unref(t)('历史采购未使用数量')
                  }, null, 8, ["label"])),
              _createVNode(_component_el_table_column, {
                prop: "productSku",
                label: _unref(t)('操作'),
                width: "160"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("a", {
                      class: "btn",
                      onClick: ($event: any) => (handleEditNum(scope.row))
                    }, _toDisplayString(_unref(t)('编辑补货数量')), 9, _hoisted_13)
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_pagination, _mergeProps(_paginationConfig.value, {
              total: pageQuery.value.total,
              pageSize: pageQuery.value.pageSize,
              "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageQuery.value.pageSize) = $event)),
              currentPage: pageQuery.value.pageNum,
              "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((pageQuery.value.pageNum) = $event)),
              style: {"justify-content":"flex-end","margin-top":"20px"},
              onCurrentChange: changePage,
              onSizeChange: changeSize,
              "append-size-to": "body",
              "popper-class": "replenish-dialog-page"
            }), null, 16, ["total", "pageSize", "currentPage"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: "btn-cancel",
            onClick: close
          }, _toDisplayString(_unref(t)('暂不支付')), 1),
          _createElementVNode("div", {
            class: "btn-pay",
            onClick: handleOrderList
          }, _toDisplayString(_unref(t)('确认采购明细')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})